import { addPageAction as nrAddPageAction } from '../../new-relic';

export function addPageAction(name: string, attributes?: object): void {
    nrAddPageAction(`scorecard.${name}`, attributes);
}
